<template>
    <div>
        <ol class="itinerary">
            <li>
                <b-row>
                    <b-col sm="3" class="date"><b>Mon, 18 Apr</b></b-col>
                    <b-col sm="9" class="info">
                        <b>Arrive in Beijing</b>
                        <ul>
                            <li>Check into Legendale/Regent hotel</li>
                            <li>Welcome cocktail reception at 7.30pm</li>
                        </ul>
                    </b-col>
                </b-row>
            </li>
            <li>
                <b-row>
                    <b-col sm="3" class="date"><b>Tue, 19 Apr</b></b-col>
                    <b-col sm="9" class="info">
                        <b>Full-day meeting</b>
                        <ul>
                            <li>Full-day meeting</li>
                            <li>GLG Team dinner </li>
                        </ul>
                    </b-col>
                </b-row>
            </li>
            <li>
                <b-row>
                    <b-col sm="3" class="date"><b>Wed, 20 Apr</b></b-col>
                    <b-col sm="9" class="info">
                        <b>Full-day meeting</b>
                        <ul>
                            <li>Full-day meeting</li>
                            <li>Gala dinner</li>
                        </ul>
                    </b-col>
                </b-row>
            </li>
            <li>
                <b-row>
                    <b-col sm="3" class="date"><b>Thur, 21 Apr</b></b-col>
                    <b-col  sm="9" class="info">
                        <b>Teambuilding</b>
                        <ul>
                            <li>Teambuilding activity</li>
                            <li>Departmental dinner</li>
                        </ul>
                    </b-col>
                </b-row>
            </li>
            <li>
                <b-row>
                    <b-col sm="3" class="date"><b>Fri, 22 Apr</b></b-col>
                    <b-col sm="9" class="info">
                        <b>Depart Beijing</b>
                        <ul>
                            <li>Check out of Legendale/Regent hotel</li>
                            <li>Depart Beijing</li>
                        </ul>
                    </b-col>
                </b-row>
            </li>				
        </ol>
        <!-- <footer class="text-center">
        <a class="btn btn-primary tabsBtn" @click="proceedToTerms">Proceed with Registration</a>
        </footer> -->
    </div>
</template>
<script>
export default {
    name: 'Itinerary',
    methods: {
        // proceedToTerms(e) {
        //     this.$emit('proceedToTerms');
        //     e.stopPropogation;
        // }
    }
}
</script>

<style lang="less" scoped>
.itinerary {
    margin-bottom: 1.2rem;
	padding: 0;
	list-style: none;
    
    ul {
        margin-top: 0.5rem;
        margin-bottom: 1em;
    }

	> li {
		border-bottom: 1px solid lighten(@blue,50);
		padding-bottom: 1em;
		margin-bottom: 1em;
    }
	
	b {
		color: @blue;
		
	}
}
</style>